import React, { useEffect, useState } from "react";
import "./ServiceBilling.scss";

import { Box, Text, Grid, Center } from "@chakra-ui/react";
import axios from "axios";
import ServicePricingSkeleton from "../../ServicePricingSkeleton";
import ServicePricingContent from "../../ServicePricingContent";

const ServiceBilling = () => {
  const [services, setServices] = useState([]);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_API}packages`)
      .then((res) => {
        setServices(res.data.data);
      })
      .catch((err) => console.log({ err }));
  }, []);

  const basicIndex = services.findIndex((service) => service.name === "basic");
  const premiumIndex = services.findIndex(
    (service) => service.name === "premium"
  );
  const businessesIndex = services.findIndex(
    (service) => service.name === "businesses"
  );

  return (
    <div className="billing">
      <Box sx={{ textAlign: "center", my: 5, pt: 8 }}>
        <Center>
          <Text
            sx={{
              color: "#213C5C",
              fontSize: "40px",
              fontWeight: "bold",
              textAlign: "center",
            }}
            style={{ py: 1 }}
          >
            Services and Pricing
          </Text>
        </Center>
      </Box>
      <Grid
        templateColumns={[
          "repeat(1, 1fr)",
          null,
          "repeat(2, 1fr)",
          null,
          "repeat(3, 1fr)",
        ]}
        sx={{ mx: 8 }}
      >
        {!services.length > 0 && (
          <>
            <ServicePricingSkeleton />
            <ServicePricingSkeleton />
            <ServicePricingSkeleton />
          </>
        )}

        {services.length > 0 && (
          <>
            <ServicePricingContent
              service={services[basicIndex]}
              imgSrc="/images/individual.png"
            />
            <ServicePricingContent
              service={services[businessesIndex]}
              imgSrc="/images/basic.png"
            />
            <ServicePricingContent
              service={services[premiumIndex]}
              imgSrc="/images/premium.png"
            />
          </>
        )}
      </Grid>
    </div>
  );
};

export default ServiceBilling;
